import { render, staticRenderFns } from "./AddPicBranchBanner.vue?vue&type=template&id=f05b2908&scoped=true"
import script from "./AddPicBranchBanner.vue?vue&type=script&lang=js"
export * from "./AddPicBranchBanner.vue?vue&type=script&lang=js"
import style0 from "./AddPicBranchBanner.vue?vue&type=style&index=0&id=f05b2908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05b2908",
  null
  
)

export default component.exports